import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await login(form.username, form.password);
      navigate('/dashboard');
    } catch {
      setError('Identifiants incorrects.');
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <img src="/icon-.png" alt="Classroom BNN" className="logo-icon" />
          <h1>Classroom BNN</h1>
          <p>Enseignement en ligne</p>
        </div>
        {error && <div className="error-msg"><i className="bi bi-exclamation-circle" /> {error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nom d'utilisateur</label>
            <input
              className="form-control"
              type="text"
              placeholder="Entrez votre identifiant"
              value={form.username}
              onChange={(e) => setForm({ ...form, username: e.target.value })}
              required
            />
          </div>
          <div className="form-group">
            <label>Mot de passe</label>
            <input
              className="form-control"
              type="password"
              placeholder="Entrez votre mot de passe"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary">
            <i className="bi bi-box-arrow-in-right" /> Se connecter
          </button>
        </form>
        <div className="auth-footer">
          Pas de compte ? <Link to="/register">S'inscrire</Link>
        </div>
      </div>
    </div>
  );
}
